const STATIC_SHOWCASE_PATH = "/gamification-showcase";

/** The public Pages showcase must boot without API probes or app prefetches. */
export function isStaticGamificationShowcasePath(pathname: string): boolean {
  const normalized = pathname.replace(/\/+$/, "") || "/";
  return normalized === STATIC_SHOWCASE_PATH;
}
